import React from "react";
import classNames from "classnames";

type VariantOption = "cannabinoid" | "subcategory" | "phenotype";

type Props = {
  className?: string;
  children: React.ReactNode;
  variant: VariantOption;
};

const BACKGROUND_COLORS: { [Variant in VariantOption]: string } = {
  cannabinoid: "bg-white",
  phenotype: "bg-leafly-white",
  subcategory: "bg-leafly-white",
};

const Classification: React.FC<Props> = ({
  className,
  variant,
  children,
  ...others
}) => {
  const classes = classNames(
    "inline-block text-xs px-sm rounded font-bold text-default",
    BACKGROUND_COLORS[variant],
    className,
  );

  return (
    <span className={classes} {...others}>
      {children}
    </span>
  );
};

export default Classification;
